import React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import SearchableSelect from '../SearchableSelect';
import { SucursalVenta } from '../../services/sucursalesVentaService';
import { sucursalVentaSelectOptions } from '../../hooks/useSucursalesVentaFiltro';

interface FiltroSucursalVentaSelectProps {
  value: number | null;
  onChange: (value: number | null) => void;
  loading?: boolean;
  sucursales: SucursalVenta[];
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

const FiltroSucursalVentaSelect: React.FC<FiltroSucursalVentaSelectProps> = ({
  value,
  onChange,
  loading,
  sucursales,
  size = 'medium',
  sx,
}) => (
  <SearchableSelect
    label="Sucursal"
    allowEmpty
    emptyOptionLabel="Todas"
    loading={loading}
    size={size}
    value={value}
    onChange={(v) => onChange(v ?? null)}
    options={sucursalVentaSelectOptions(sucursales)}
    sx={{
      '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: '#fafafa' },
      ...sx,
    }}
  />
);

export default FiltroSucursalVentaSelect;

